<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Detalles de Orden de Compra</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(isChanged)"></i></h1>
				</div>
				<div class="modal-body">
					<div *ngIf="order != null">
						<h6>Orden: {{ order.number }}</h6>
						<h6>Proveedor: {{ order?.providerData?.name || 'Desconocido' }}</h6>
						<h6>Fecha de Creación: {{ formatDate(order?.creationDate) | date: 'dd/MM/yyyy' }}</h6>
						<h6>Fecha de Entrega: {{ formatDate(order?.deliveryDate) | date: 'dd/MM/yyyy' }}</h6>
						<!-- <div>
							<h6 *ngIf="!editDeliveryDate" (click)="editDeliveryDate = true" class="i-hover">
								Fecha de Entrega: {{ formatDate(order?.deliveryDate) | date: 'dd/MM/yyyy' }} <i class="fa fa-edit span-hover"></i>
							</h6>
							<div *ngIf="editDeliveryDate" class="d-flex align-items-center gap-2 input-group input-group-sm">
								<label for="deliveryDate">Fecha de Entrega:</label>
								<input type="date" id="deliveryDate" class="form-control"
									[(ngModel)]="order.deliveryDate" style="max-width: 150px;"
									[value]="order.deliveryDate"
										/>
								<button class="btn btn-success btn-sm rounded-1"
									(click)="saveDeliveryDate()"
									[disabled]="loadingDeliveryDate">
									<ng-container *ngIf="!loadingDeliveryDate">
										<i class="fa fa-floppy-disk"></i> Guardar
									</ng-container>
									<ng-container *ngIf="loadingDeliveryDate">
										<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										<span role="status"></span>
									</ng-container>
								</button>
								<button class="btn btn-danger btn-sm rounded-1"
									(click)="editDeliveryDate = false">
									Cancelar
								</button>
							</div>
						</div> -->
					</div>
					<div class="table-responsive" style="margin-top: 1em;">
						<table class="table table-bordered" style="margin-bottom: 0; margin-top: 1em;">
							<thead>
								<tr>
									<!-- <th class="ta">Orden</th> -->
									<th class="ta">Producto</th>
									<th class="ta">Bodega</th>
									<th class="text-right">Cantidad a Recibir</th>
									<th class="text-right">Costo</th>
									<th class="text-center">
										Moneda <button class="btn btn-sm btn-light btn-info" (click)="updateExchange()" [disabled]="loadingCurrency" *ngIf="order && !order.enteredIntoInventory">
											<i *ngIf="!loadingCurrency" class="fa fa-exchange"></i>
											<i *ngIf="loadingCurrency" class="fa fa-spinner"></i>
											<span *ngIf="currencyType==0">{{ ' $' }}</span>
											<span *ngIf="currencyType==1">{{ ' Q' }}</span>
										</button>
										<!-- <span class="btn btn-sm btn-light btn-info">
											<i *ngIf="!loadingCurrency" class="fa fa-exchange"></i>
											<i *ngIf="loadingCurrency" class="fa fa-floppy-disk"></i>
											<span *ngIf="currencyType==0">{{ ' $' }}</span>
											<span *ngIf="currencyType==1">{{ ' Q' }}</span>
										</span> -->
									</th>
									<th class="text-right">Subtotal</th>
									<th class="ta" *ngIf="order && !order.enteredIntoInventory">
										Acción
									</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let item of orderDetails">
									<tr>
										<!-- <td>{{ item.purchaseOrder }}</td> -->
										<td>{{ item.productData.name }}</td>
										<td>{{ item.warehouseData? item.warehouseData.name : item.warehouse }}</td>
										<td [class.text-right]="editingItem!=item.id">
											<span *ngIf="editingItem!=item.id">{{ item.quantity }}</span>

											<div *ngIf="editingItem==item.id" class="d-flex justify-end">
												<input type="number" class="form-control" [(ngModel)]="item.quantity" [disabled]="item.statusType!=0"
													style="max-width: 100px; text-align: center;" step="0.01" min="0"/>
											</div>
										</td>
										<td [class.text-right]="editingItem!=item.id">
											<span *ngIf="editingItem!=item.id && currencyType==0">{{ item.cost | currency:"Q" }}</span>
											<span *ngIf="editingItem!=item.id && currencyType==1">{{ item.cost | currency:"USD" }}</span>

											<div *ngIf="editingItem==item.id" class="d-flex justify-end">
												<input type="number" class="form-control" [(ngModel)]="item.cost" [disabled]="item.statusType!=0"
													style="max-width: 100px; text-align: center;" step="0.01" min="0"/>
											</div>
										</td>
										<td class="text-center">
											<span *ngIf="currencyType==0">{{ 'Q' }}</span>
											<span *ngIf="currencyType==1">{{ '$' }}</span>
										</td>
										<td class="text-right">
											<span *ngIf="editingItem!=item.id && currencyType==0">{{ item.cost*item.quantity | currency:"Q" }}</span>
											<span *ngIf="editingItem!=item.id && currencyType==1">{{ item.cost*item.quantity | currency:"USD" }}</span>
										</td>
										<td class="ta" *ngIf="order && !order.enteredIntoInventory">
											<div class="d-flex justify-center items-center">
												<div *ngIf="editingItem!=item.id && item.statusType==0" class="d-flex justify-center items-center">
													<span (click)="startEditing(item)" class="text-info">
														<ng-container>
															<i class="fa fa-edit"></i>
														</ng-container>
													</span>
												</div>
												<div *ngIf="editingItem==item.id && item.statusType==0" class="d-flex justify-center items-center gap-1">
													<button class="btn btn-success"
														[disabled]="loading[order.id]"
														(click)="saveItem(item)"
														>
														<ng-container *ngIf="!loading[order.number]">
															<i class="fa fa-floppy-disk"></i>
														</ng-container>
														<ng-container *ngIf="loading[order.number]">
															<span
																class="spinner-border spinner-border-sm"
																aria-hidden="true"></span>
															<span role="status"></span>
														</ng-container>
													</button>
													<button (click)="endEditing(item)" class="btn btn-danger">
														<ng-container>
															<i class="fa fa-cancel"></i>
														</ng-container>
													</button>
												</div>
											</div>
										</td>
									</tr>
								</ng-container>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="5" class="text-right font-weight-bold">Total</td>
									<td class="text-right font-weight-bold">
										<span *ngIf="currencyType==0">{{ totalCost.toFixed(2) | currency:"Q" }}</span>
										<span *ngIf="currencyType==1">{{ totalCost.toFixed(2) | currency:"USD" }}</span>
									</td>
									<td *ngIf="order && !order.enteredIntoInventory"></td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="mt-3" *ngIf="orderId">
						<h6 class="mb-2">Recepción</h6>

						<!-- No hay recibida -->
						<div *ngIf="!receivedOrder" class="text-muted">
							<i class="fa fa-circle-info"></i> Esta orden no tiene recepción registrada.
						</div>

						<!-- Si hay recibida -->
						<div *ngIf="receivedOrder" class="card">
							<div class="card-body p-2">
							<div class="row g-2">
								<div class="col-6">
								<small class="text-muted">Piloto</small>
								<div>{{ receivedOrder.pilot || '—' }}</div>
								</div>
								<div class="col-6">
								<small class="text-muted">Licencia</small>
								<div>{{ receivedOrder.pilotLicense || '—' }}</div>
								</div>

								<div class="col-6">
								<small class="text-muted">Placa carro</small>
								<div>{{ receivedOrder.plateCar || '—' }}</div>
								</div>
								<div class="col-6">
								<small class="text-muted">Placa plataforma</small>
								<div>{{ receivedOrder.platePlatform || '—' }}</div>
								</div>

								<div class="col-6">
								<small class="text-muted">Contenedor</small>
								<div>{{ receivedOrder.container || '—' }}</div>
								</div>
								<div class="col-6">
								<small class="text-muted">Fecha</small>
								<div>{{ receivedOrder.creationDate | date:'dd/MM/yyyy HH:mm' }}</div>
								</div>
							</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="modal-footer">
					<button class="btn btn-success" (click)="createOrder()"
					 [disabled]="loading || !inputs.warehouse.verified || !date || productList.length == 0">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div> -->
			</div>
		</div>
	</div>
</div>